"use client";
import React, {useState} from "react";
import clsx from "clsx";

export default function HeroWithForm({data}) {
    const {
        title,
        subtitle,
        badge,
        background = {},
        align = "center",
        padding = "xl",
        form = {}
    } = data || {};

    const bgStyle =
        background.type === "gradient"
            ? {backgroundImage: background.value}
            : background.type === "color"
                ? {backgroundColor: background.value}
                : background.type === "image"
                    ? {
                        backgroundImage: `url(${background.value})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }
                    : {};

    const paddingMap = {
        sm: "py-10 px-4",
        md: "py-16 px-6",
        lg: "py-20 px-6",
        xl: "py-28 px-8"
    };

    const [email, setEmail] = useState("");

    return (
        <section className={`${paddingMap[padding] || "py-20 px-6"}`} style={bgStyle}>
            <div className={clsx("max-w-3xl mx-auto", align === "center" ? "text-center" : "")}>
                {badge && (
                    <div
                        className="inline-flex items-center mb-4 text-sm font-medium text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
                        {badge.icon && <img src={badge.icon} alt="badge" className="w-4 h-4 mr-2"/>}
                        {badge.text}
                    </div>
                )}
                {title && <h1 className="text-4xl sm:text-5xl font-bold mb-4">{title}</h1>}
                {subtitle && <p className="text-lg text-gray-600 mb-6">{subtitle}</p>}

                {form?.enabled && (
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            console.log("Submit email:", email);
                        }}
                        className="mt-6 flex flex-col sm:flex-row items-center gap-4 justify-center"
                    >
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder={form.placeholder || "Your email"}
                            className="w-full sm:w-2/3 px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <button
                            type="submit"
                            className="w-full sm:w-auto px-6 py-3 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition"
                        >
                            {form.buttonText || "Submit"}
                        </button>
                    </form>
                )}
            </div>
        </section>
    );
}